import {
  instance as axios,
  instanceDownloadFile as axiosDF,
} from "../../configs/axios";

export default {
  getListStores: () => axios.get(`/StockAdjustment/GetStores`),
  processAdjustExcel: (options = { params: [] }) => axios.post(`/StockAdjustment/ProcessAdjustExcel`, options),
  uploadDraft: (options = { params: [] }) => axios.post(`/StockAdjustment/UploadDraft`, options),
  updateDraft: (options = { params: [] }) => axios.post(`/StockAdjustment/UpdateDraft`, options),
  getDraftList: (startDate, endDate) => axios.get(`/StockAdjustment/GetDraftList/?startDate=${startDate}&endDate=${endDate}`),
  getDraftDetail: (draftNumber) => axios.get(`/StockAdjustment/GetDraftDetail/?draftNumber=${draftNumber}`),
  getAdjustmentList: (startDate, endDate) => axios.get(`/StockAdjustment/GetAdjustmentList/?startDate=${startDate}&endDate=${endDate}`),
  getAdjustmentDetail: (adjustmentNumber) => axios.get(`/StockAdjustment/GetAdjustmentDetail/?adjustmentNumber=${adjustmentNumber}`),
  updateDraftAdjustment: (options = { params: [] }) => axios.post(`/StockAdjustment/UpdateDraftAdjustment`, options),
  discardDraft: (options = { params: [] }) => axios.post(`/StockAdjustment/DiscardDraft`, options),
  getLimitFetchDays: () => axios.get(`/StockAdjustment/GetLimitFetchDays`),
  downloadAllStockAdjustment: (startDate, endDate) => axiosDF.get(`/StockAdjustment/DownloadAllStockAdjustment/?startDate=${startDate}&endDate=${endDate}`),
  downloadFileDraft: (draftNumber) => axiosDF.get(`/StockAdjustment/DownloadFileDraft/?draftNumber=${draftNumber}`),
  getLPNFile: (adjustmentNumber) => axiosDF.get(`/StockAdjustment/GetLPNFile?adjustmentNumber=${adjustmentNumber}`),
  getPackingListFile: (adjustmentNumber) => axiosDF.get(`/StockAdjustment/GetPackingListFile?adjustmentNumber=${adjustmentNumber}`),
};
